/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useRef, useState } from 'react';

import * as React from 'react';
import { CSSTransition } from 'react-transition-group';

export interface SelectedRowsStatusProps {
	isOpen: boolean;
	numOfSelected: number;
	numTotal: number;
	actionButtons: React.ReactNode;
}

const SelectedRowsStatus = ({ isOpen, numOfSelected, numTotal, actionButtons }: SelectedRowsStatusProps): JSX.Element => {
	const [naturalHeight, setNaturalHeight] = useState(0);
	const captionBody = useRef<HTMLTableCaptionElement>(null);

	const TransitionStates = {
		onEnter: () => {
			captionBody.current!.style.height = '';
			setNaturalHeight(captionBody.current!.offsetHeight);
			captionBody.current!.style.height = '0';
		},
		onEntering: () => {
			captionBody.current!.style.height = `${naturalHeight}px`;
		},
		onEntered: () => {
			captionBody.current!.style.height = '';
		},
		onExit: () => {
			captionBody.current!.style.display = 'table-caption';
			captionBody.current!.style.height = `${captionBody.current!.offsetHeight}px`;
		},
		onExiting: () => {
			captionBody.current!.style.height = '0';
		},
		onExited: () => {
			captionBody.current!.style.height = '';
			captionBody.current!.style.display = '';
		},
	};

	return (
		<CSSTransition in={isOpen} timeout={300} {...TransitionStates}>
			<caption className={`table-status table-status-transition${isOpen ? ' show' : ''}`} aria-expanded={isOpen} ref={captionBody}>
				<div>
					<div>
						<span>{`${numOfSelected} ud af ${numTotal} valgt`}</span>
					</div>
					<div className="p-1">{actionButtons}</div>
				</div>
			</caption>
		</CSSTransition>
	);
};
SelectedRowsStatus.defaultProps = {};

export { SelectedRowsStatus };
